import React from 'react'

export const AppContext = React.createContext({
  viewer: null,
})

export function withAppContext(Component) {
  function ComponentWithAppContext(props) {
    return (
      <AppContext.Consumer>
        {appContext => <Component {...props} {...appContext} />}
      </AppContext.Consumer>
    )
  }

  ComponentWithAppContext.fetchData = Component.fetchData

  return ComponentWithAppContext
}
